import { WidgetPresence } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import type { Action, Dispatch } from 'redux';

import type { RootReducerStateT } from 'app/reducers/rootReducer';

import DemoWidget, {
  PropsT as DemoWidgetPropsT,
} from '../components/DemoWidget';
import type {
  FlowChatNodeWidgetCustomizationPayloadT,
  LocalizationsPayloadT,
} from '../components/nodeTypes/widgetcustomization';

export type DemoWidgetStatePropsT = {
  settings?: null | DemoWidgetSettingsT;
  widget_id?: null | string;
};

type DemoWidgetSettingsT = {
  localization: LocalizationsPayloadT;
} & Omit<
  FlowChatNodeWidgetCustomizationPayloadT,
  'localizations' | 'nextNodeId'
>;

export type DemoWidgetDispatchPropsT = {
  changeSelectedLanguage: (locale: string) => void;
  changeSelectedView: (locale: string) => void;
  changeWidgetTypeShown: (widgetType: string) => void;
  changeWidgetState: (payload: Partial<WidgetPresence>) => void;
};

const mapStateToProps = (
  state: RootReducerStateT,
  ownProps: Omit<DemoWidgetStatePropsT, 'settings'>,
): DemoWidgetStatePropsT => {
  const payloadSettings = Object.assign({}, state.nodeWidgetCustomization);
  const settings: null | DemoWidgetSettingsT = payloadSettings
    ? {
        localization: payloadSettings.localizations,
        theme: payloadSettings.theme,
        medium: payloadSettings.medium,
        small: payloadSettings.small,
      }
    : null;

  return {
    ...ownProps,
    settings,
    widget_id: state.chatFlow.widget_id,
  };
};

const mapDispatchToProps = (
  _dispatch: Dispatch<Action>,
  ownProps: DemoWidgetDispatchPropsT,
): DemoWidgetDispatchPropsT => {
  return {
    ...ownProps,
  };
};

export default connect<
  DemoWidgetStatePropsT,
  DemoWidgetDispatchPropsT,
  DemoWidgetPropsT,
  RootReducerStateT
>(
  mapStateToProps,
  mapDispatchToProps,
)(DemoWidget);
